import {createApi} from '@reduxjs/toolkit/query/react';
import {SearchResults} from 'app/types/Shared';

import {baseQuery} from 'app/helpers/auth';

export const searchApi = createApi({
  reducerPath: 'searchApi',
  baseQuery: baseQuery,
  tagTypes: ['SearchResults'],
  endpoints(builder) {
    return {
      searchByKeyword: builder.query<SearchResults, string>({
        query: (keyword) => {
          return {
            url: `/search?q=${keyword}`,
            method: 'GET',
          };
        },
      }),
    };
  },
});

export const {useSearchByKeywordQuery} = searchApi;
